<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Spray Data</h1>
        <div class="pull-right">
          <div class="btn-group">
            <button
              class="pointer btn btn-lg btn-primary"
              v-on:click="showEdit('truck')"
            >
              Enter Truck Data
            </button>
            <button
              class="pointer btn btn-lg btn-primary"
              v-on:click="getCsv()"
              title="Upload truck spray record"
            >
              <i class="fa fa-truck"></i>
            </button>
            <button
              class="pointer btn btn-lg btn-primary"
              v-on:click="showEdit('barrier')"
            >
              Enter Barrier Data
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="panel">
      <search-fields :form="form" :fields="searchFieldsList"></search-fields>

      <loading :working="form.working()"></loading>

      <div class="panel-body" v-if="!form.working()">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Type</th>
                <th>Site/Contract</th>
                <th>Application Date</th>
                <th>Applicator</th>
                <th>Chemical</th>
                <th>Zone</th>
                <th>Spray Start/End</th>
                <th>Spray Miles</th>
                <th>Ounces Sprayed</th>
                <th>Work Status</th>
                <th width="120"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in form.list">
                <td>
                  <span v-if="item.attributes.contractId">Truck</span>
                  <span v-if="item.attributes.siteId">Barrier</span>
                </td>
                <td>
                  <span v-if="item.attributes.siteId">{{
                    siteName(item.attributes.siteId)
                  }}</span>
                  <span v-if="item.attributes.contractId">{{
                    contractName(item.attributes.contractId)
                  }}</span>
                </td>
                <th>{{ item.attributes.applicationDate | date }}</th>
                <td>{{ applicatorName(item.attributes.applicatorId) }}</td>
                <td>{{ achemicalName(item.attributes.achemicalId) }}</td>
                <td>{{ zoneName(item.attributes.zoneId) }}</td>
                <td>
                  {{ item.attributes.startTime | time }} -
                  {{ item.attributes.endTime | time }}
                </td>
                <td>{{ item.attributes.sprayMiles }}</td>
                <td>{{ item.attributes.ouncesSprayed }}</td>
                <td>{{ item.attributes.workStatus }}</td>

                <td>
                  <!--<a class="pointer text-primary" v-on:click="form.showEdit({id: item.id})"><i class="fa fa-pencil" style="margin-right: 10px;"></i></a>-->
                  <router-link
                    :to="{
                      name: 'data-adulticide-details',
                      params: { id: item.id },
                    }"
                    ><i class="fa fa-ellipsis-h" style="margin-right: 10px;"></i
                  ></router-link>
                  <a
                    class="pointer text-danger"
                    v-on:click="form.destroy(item.id)"
                    ><i class="fa fa-times"></i
                  ></a>
                </td>
              </tr>
            </tbody>

            <pager :form="form"></pager>
          </table>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>
    <input type="file" id="csv" v-on:change="readCsv()" />
  </div>
</template>

<script>
import AdulticideService from '@/services/AdulticideService';
import Form from '@/utils/form';
import loader from '@/utils/loader';
import siteForm from '@/components/forms/adulticide';
import pager from '@/components/forms/pager';
import csvjson from 'csvjson';
import searchFields from '@/components/search_fields';
import loading from '@/components/loading';

import store from '@/store';

export default {
  name: 'adulticide',

  components: {
    siteForm,
    pager,
    searchFields,
    loading,
  },

  props: ['type', 'id', 'contractId'],

  data() {
    return {
      searchFieldsList: { site: 'Site', zone: 'Zone' },
      form: new Form(AdulticideService, {
        csv: null,
        truck: false,
        barrier: false,
        vizualMonitorPerformed: true,
        workStatus: 'Completed by technician',
      }),
    };
  },

  methods: {
    siteName(id) {
      return this.$store.getters.siteNameById(id);
    },
    contractName(id) {
      return this.$store.getters.contractNameById(id);
    },
    municipalityName(id) {
      return this.$store.getters.municipalityNameById(id);
    },
    applicatorName(id) {
      return this.$store.getters.applicatorNameById(id);
    },
    achemicalName(id) {
      return this.$store.getters.achemicalNameById(id);
    },
    zoneName(id) {
      return this.$store.getters.zoneNameById(id);
    },
    getCsv() {
      document.querySelector('#csv').click();
    },
    readCsv() {
      let files = document.querySelector('#csv').files;
      if (!files.length) {
        return;
      }

      var that = this;
      let fileReader = new FileReader();
      fileReader.onloadend = () => {
        let csvOptions = {
          delimiter: ',',
          quote: '"',
        };
        that.form.csv = csvjson.toObject(fileReader.result, csvOptions);
        that.form.showEdit({});
      };
      fileReader.readAsText(files[0]);
    },
    showEdit(type) {
      if (type === 'truck') {
        this.form.data.truck = true;
        this.form.data.barrier = false;
        this.form.showEdit({ title: 'Add Truck ULV Data' });
      } else {
        this.form.data.truck = false;
        this.form.data.barrier = true;
        this.form.showEdit({ title: 'Add Adulticide Data' });
      }
    },
  },

  created() {
    if (this.$props.type !== 'sr') {
      return;
    }
    window.bus.$on('item-created', (id) => {
      if (this.$route.path.indexOf('adulticide') > -1 && this.$props.id) {
        this.$router.push({
          name: 'data-service-request-details',
          params: { id: this.$props.id },
        });
      }
    });

    $(document).on('hide.bs.modal', () => {
      if (this.$route.path.indexOf('adulticide') > -1 && this.$props.id) {
        this.$router.push({
          name: 'data-service-request-details',
          params: { id: this.$props.id },
        });
      }
    });
  },

  mounted() {
    loader.lookups().then(() => {
      this.form.getList();
    });
    if (this.$props.id) {
      this.showEdit({});
      if (this.$props.type === 's') {
        this.form.siteSearch.term = this.siteName(this.$props.id);
        this.form.onSiteSearch('siteId');
      } else if (this.$props.type === 'sr') {
        this.form.data.serviceRequestId = this.$props.id;
        if (this.$props.contractId) {
          this.form.data.contractId = this.$props.contractId;
          this.form.data.barrier = true;
          this.form.data.truck = false;
        }
      }
    }
  },
};
</script>

<style lang="scss">
#csv {
  display: none;
}
</style>
